(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-builder-product"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatMoney(cents, format) {
      format = format || '${{amount}}';
      var placeholder = /\{\{\s*(\w+)\s*\}\}/;
      function withDelimiters(number, precision, thousands, decimal) {
        precision = precision == null ? 2 : precision;
        thousands = thousands == null ? ',' : thousands;
        decimal = decimal == null ? '.' : decimal;
        if (isNaN(number) || number == null) return '0';
        number = (number / 100).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var rest = parts[1] ? decimal + parts[1] : '';
        return dollars + rest;
      }
      var value = '';
      var match = format.match(placeholder);
      switch (match && match[1]) {
        case 'amount': value = withDelimiters(cents, 2); break;
        case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
        case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
        default: value = withDelimiters(cents, 2);
      }
      return format.replace(placeholder, value);
    }

    function fetchJSON(url, opts) {
      opts = opts || {};
      opts.credentials = 'same-origin';
      opts.headers = Object.assign({ Accept: 'application/json' }, opts.headers || {});
      return fetch(url, opts).then(function (r) {
        var ct = r.headers.get('content-type') || '';
        if (ct.indexOf('application/json') !== -1) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        }
        return r.text().then(function (t) {
          if (!r.ok) throw new Error('HTTP ' + r.status + ' ' + (t || ''));
          try { return JSON.parse(t); } catch (e) { return { ok: true, raw: t }; }
        });
      });
    }

    function fetchCart() { return fetchJSON('/cart.js'); }

    function addToCart(variantId, qty) {
      var body = new URLSearchParams();
      body.set('id', String(variantId));
      body.set('quantity', String(qty || 1));
      return fetchJSON('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: body.toString()
      });
    }

    function updateCartCountEl(count) {
      try {
        document.querySelectorAll('[data-cart-count], .cart-link__count, .site-header__cart-count, [aria-label*="Cart"] .count')
          .forEach(function (el) {
            if ('textContent' in el) el.textContent = count;
            if (el.setAttribute) el.setAttribute('data-cart-count', count);
          });
      } catch (e) {}
    }

    function dispatchAllCartSignals(cart, lastItem) {
      try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } })); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart })); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { cart: cart, lineItem: lastItem } })); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('cart:update', { detail: cart })); } catch (e) {}
      try { if (window.Shopify) window.Shopify.cart = cart; } catch (e) {}
      updateCartCountEl(cart && typeof cart.item_count === 'number' ? cart.item_count : '');
    }

    function openDrawerNow() {
      try { document.dispatchEvent(new CustomEvent('cart:open')); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('theme:cart:open')); } catch (e) {}
      try {
        if (window.theme && window.theme.CartDrawer) {
          if (typeof window.theme.CartDrawer.open === 'function') window.theme.CartDrawer.open();
          if (window.theme.drawer && typeof window.theme.drawer.open === 'function') window.theme.drawer.open('cart');
        }
      } catch (e) {}
      var drawer = document.querySelector('[data-cart-drawer], #CartDrawer, .drawer--cart, .js-cart-drawer');
      if (drawer && drawer.classList) drawer.classList.add('is-open');
    }

    function findCartSectionIds() {
      var ids = new Set();
      document.querySelectorAll(
        '#CartDrawer, [data-cart-drawer], .drawer--cart, [data-section-type*="cart"], [data-section-id*="cart"], [id*="CartDrawer"], [id*="cart-drawer"]'
      ).forEach(function (node) {
        var el = node.closest('[data-section-id]') || node;
        var id = el && el.getAttribute && el.getAttribute('data-section-id');
        if (id) ids.add(id);
      });
      ['cart-drawer', 'cart-notification', 'cart-icon-bubble'].forEach(function (k) { ids.add(k); });
      return Array.from(ids);
    }

    function refreshCartSectionsThenOpen(lastItem, onDone) {
      var sectionIds = findCartSectionIds();
      if (!sectionIds.length) {
        fetchCart().then(function (cart) {
          dispatchAllCartSignals(cart, lastItem);
          setTimeout(openDrawerNow, 50);
          if (onDone) onDone(cart);
        }).catch(function () {
          openDrawerNow();
          if (onDone) onDone();
        });
        return;
      }
      var url = '/?sections=' + encodeURIComponent(sectionIds.join(','));
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('sections fetch'); return r.json(); })
        .then(function (json) {
          sectionIds.forEach(function (id) {
            var html = json[id];
            if (!html) return;
            var current = document.querySelector('[data-section-id="' + id + '"]');
            if (!current) return;
            var tmp = document.createElement('div');
            tmp.innerHTML = html.trim();
            var next = tmp.firstElementChild;
            if (next) current.replaceWith(next);
          });
        })
        .catch(function () {})
        .finally(function () {
          fetchCart().then(function (cart) {
            dispatchAllCartSignals(cart, lastItem);
            setTimeout(openDrawerNow, 50);
            if (onDone) onDone(cart);
          }).catch(function () {
            openDrawerNow();
            if (onDone) onDone();
          });
        });
    }

    function addItemsOneByOne(items) {
      var lastRes = null;
      return items.reduce(function (chain, item) {
        return chain.then(function () {
          return addToCart(item.id, item.quantity || 1).then(function (res) {
            lastRes = res;
            return res;
          });
        });
      }, Promise.resolve()).then(function () { return lastRes; });
    }

    function initBundler(root) {
      if (!root || root.__bundlerInit) return;
      root.__bundlerInit = true;

      var bundleSize = parseInt(root.getAttribute('data-bundle-size'), 10) || 2;
      var pct = parseFloat(root.getAttribute('data-discount-percentage')) || 10;
      var code = (root.getAttribute('data-discount-code') || '').trim();
      var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

      var selected = {};
      var cartCount = 0;
      var cartTotal = 0;
      var msgEl = root.querySelector('[data-bundler-message]');
      var barEl = root.querySelector('[data-bundler-bar]');
      var countEl = root.querySelector('[data-bundler-count]');
      var totalEl = root.querySelector('[data-bundler-total]');
      var addBtn = root.querySelector('[data-bundler-add]');
      if (!addBtn) return;

      function update() {
        var keys = Object.keys(selected);
        var count = keys.length;
        var effective = count + cartCount;
        var bundleTotal = keys.reduce(function (s, k) { return s + selected[k].price; }, 0);
        var grandTotal = cartTotal + bundleTotal;
        var qualifies = effective >= bundleSize;

        if (countEl) countEl.textContent = effective + ' / ' + bundleSize + ' in bundle';
        if (barEl) barEl.style.width = Math.min(effective / bundleSize, 1) * 100 + '%';

        if (msgEl) {
          if (effective === 0) {
            msgEl.textContent = 'Bundle ' + bundleSize + ' items to save ' + pct + '%';
          } else if (!qualifies) {
            var left = bundleSize - effective;
            msgEl.textContent = 'Bundle with ' + left + ' item' + (left > 1 ? 's' : '') + ' to get ' + pct + '% off';
          } else {
            msgEl.textContent = "You've unlocked " + pct + '% off! ✅ ';
          }
        }

        if (totalEl) {
          if (qualifies && grandTotal > 0) {
            var discounted = Math.round(grandTotal * (1 - pct / 100));
            totalEl.innerHTML =
              '<span class="bundler__strike">' + formatMoney(grandTotal, moneyFormat) + '</span>' +
              '<span class="bundler__discounted">' + formatMoney(discounted, moneyFormat) + '</span>';
          } else {
            totalEl.textContent = formatMoney(grandTotal, moneyFormat);
          }
        }

        addBtn.disabled = count === 0;
        addBtn.textContent = qualifies ? ('Add to cart & apply ' + pct + '% off') : 'Add to cart';
      }

      function resetCard(card) {
        card.classList.remove('is-selected');
        card.setAttribute('aria-pressed', 'false');
        var select = card.querySelector('[data-bundler-variant]');
        if (select) select.value = '';
      }

      function clearSelection() {
        selected = {};
        root.querySelectorAll('.bundler__card.is-selected').forEach(resetCard);
      }

      function loadCartData() {
        return fetchCart().then(function (cart) {
          cartCount = (cart && cart.item_count) || 0;
          cartTotal = (cart && cart.total_price) || 0;
          update();
          return cart;
        }).catch(function () { update(); });
      }

      function onExternalCartChange(e) {
        var cart = e && e.detail;
        if (cart && typeof cart.item_count === 'number') {
          cartCount = cart.item_count;
          cartTotal = cart.total_price || 0;
          update();
          return;
        }
        loadCartData();
      }

      ['cart:updated', 'cart:refresh', 'cart:update', 'ajaxProduct:added', 'theme:cart:change'].forEach(function (evt) {
        document.addEventListener(evt, onExternalCartChange);
      });

      root.querySelectorAll('.bundler__card').forEach(function (card) {
        if (card.classList.contains('is-unavailable')) return;

        var key = card.getAttribute('data-product-key');
        var select = card.querySelector('[data-bundler-variant]');
        var checkBtn = card.querySelector('[data-bundler-deselect]');
        var priceEl = card.querySelector('[data-bundler-price]');
        var saleEl = card.querySelector('[data-bundler-price-sale]');

        function renderPrices(price) {
          if (priceEl) priceEl.textContent = formatMoney(price, moneyFormat);
          if (saleEl) saleEl.textContent = formatMoney(Math.round(price * (1 - pct / 100)), moneyFormat);
        }

        function selectCard(variant) {
          selected[key] = variant;
          card.classList.add('is-selected');
          card.setAttribute('aria-pressed', 'true');
          update();
        }

        function deselectCard() {
          delete selected[key];
          card.classList.remove('is-selected');
          card.setAttribute('aria-pressed', 'false');
          if (select) select.value = '';
          renderPrices(parseInt(card.getAttribute('data-price'), 10));
          update();
        }

        if (checkBtn) {
          checkBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            deselectCard();
          });
        }

        if (select) {
          select.addEventListener('click', function (e) { e.stopPropagation(); });
          select.addEventListener('keydown', function (e) { e.stopPropagation(); });
          select.addEventListener('change', function () {
            if (!select.value) return;
            var opt = select.options[select.selectedIndex];
            var variant = { id: select.value, price: parseInt(opt.getAttribute('data-price'), 10) };
            renderPrices(variant.price);
            selectCard(variant);
          });
          function focusSelect() {
            if (typeof select.showPicker === 'function') { try { select.showPicker(); return; } catch (e) {} }
            select.focus();
          }
          card.addEventListener('click', focusSelect);
          card.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); focusSelect(); }
          });
        } else {
          function addCard() {
            if (card.getAttribute('data-available') !== 'true' || selected[key]) return;
            selectCard({
              id: card.getAttribute('data-variant'),
              price: parseInt(card.getAttribute('data-price'), 10)
            });
          }
          card.addEventListener('click', addCard);
          card.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); addCard(); }
          });
        }
      });

      addBtn.addEventListener('click', function () {
        var keys = Object.keys(selected);
        if (!keys.length) return;

        var items = keys.map(function (k) { return { id: selected[k].id, quantity: 1 }; });
        var qualifies = (keys.length + cartCount) >= bundleSize;

        addBtn.disabled = true;
        var prev = addBtn.textContent;
        addBtn.textContent = 'Adding...';

        addItemsOneByOne(items)
          .then(function (lastRes) {
            var lastItem = lastRes && (lastRes.item || lastRes);
            if (!lastItem && lastRes && Array.isArray(lastRes.items) && lastRes.items[0]) {
              lastItem = lastRes.items[0];
            }

            var chain = Promise.resolve();
            if (qualifies && code) {
              chain = chain.then(function () {
                return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
              });
            }

            return chain.then(function () {
              clearSelection();
              refreshCartSectionsThenOpen(lastItem, function (cart) {
                if (cart) {
                  cartCount = cart.item_count || 0;
                  cartTotal = cart.total_price || 0;
                  update();
                }
                addBtn.disabled = false;
                addBtn.textContent = prev;
              });
            });
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.textContent = prev;
            alert('Sorry, something went wrong adding your bundle. Please try again.');
          });
      });

      update();
      loadCartData();

      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) loadCartData();
      });
    }

    function initAll() {
      document.querySelectorAll('.bundler').forEach(initBundler);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
